import { apiToken, apiBasic, logout } from "./requests";
import { encodeToken } from "./utils";

export const logIn = (data = null) => {
  let path = "login";
  return apiToken(data, path);
};

export const validateLogIn = (data) => {
  let path = "validate";
  return apiBasic(data, path);
};

export const recoverPassword = (data = null) => {
  let path = "forgot-password";
  return apiBasic({ token: encodeToken(data) }, path);
};

export const resetPassword = (data) => {
  let path = "reset-password";
  return apiBasic({ token: encodeToken(data) }, path);
};

export const logOut = () => logout();
